import React from "react";
import Dashboard from "../pages/home/Dashboard";
import Reporting from "../pages/home/Reporting";

import CRM from "../pages/home/CRM";
import Page from "@jumbo/shared/Page";
import AuthGuard from "./AuthGuard";
import { getAuthToken } from "@jumbo/services/auth/jwtAuth";



const homeRoutes = [
  {
    path: "/home/dashboard",
    element: <AuthGuard><Page component={Dashboard} /></AuthGuard>,
  },
  {
    path: "/home/reporting",
    element: <AuthGuard><Page component={Reporting} /></AuthGuard>,
  },
  {
    path: "/home/crm",
    element: <AuthGuard><Page component={CRM} /></AuthGuard>,
  },
];

export default homeRoutes;
